const getLocalStorageKeyForOverviewLabel = (entityKey, overviewLabelKey) => {
  return ['table', 'preferences', 'columns', entityKey, overviewLabelKey].join(
    '.',
  );
};

export default getLocalStorageKeyForOverviewLabel;
